/**
* @render react
* @name Label
*/

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withPolaris } from 'Components/protons/Polaris';

/**
 * Label component
 *
 * @param {string} content - The label text.
 * @param {string} target - The form item (input,select) that the label targets.
 * @param {string} children - Anything else passed inside the label.
 * @param {boolean} loadStyles - Whether to apply the class names for styling
 * @param {Object} extraClassNames - Extra class names to be applied to the component.
 * @param {Object} context - Extra information coming from Polaris provider.
 */
const Label = (
  {
    content,
    target,
    children,
    loadStyles,
    extraClassNames,
    context: { cssPrefix },
  },
) => (
  // eslint-disable-next-line
  <label
    htmlFor={target}
    className={classNames({
      [`${cssPrefix}__label`]: loadStyles,
      ...extraClassNames,
    })}
  >
    {content}
    {children}
  </label>
);

/**
 * Valid props
 */
Label.propTypes = {
  content: PropTypes.string,
  target: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.shape(),
    PropTypes.string,
  ]),
  loadStyles: PropTypes.bool,
  extraClassNames: PropTypes.shape(),
  context: PropTypes.shape(),
};

/**
 * Default props
 */
Label.defaultProps = {
  content: 'My Label',
  target: null,
  children: null,
  loadStyles: true,
  extraClassNames: {},
  context: {},
};

export default withPolaris(Label);
